/**
  * vue-lazy-component
  */
import VueLazyComponent from './vue-lazy-component.vue';
import lazyScroll from './lazy-scroll.js';

// /**
//  * Plugin API
//  */
VueLazyComponent.install = function(Vue) {
    const instance = Vue.extend({
        ...VueLazyComponent,
        mixins: [
            {
                data() {
                    return {
                        bindScroll: lazyScroll.bindScroll()
                    };
                }
            }
        ]
    });
    Vue.component('vue-lazy-component', instance);
};
export default VueLazyComponent;

// import lazyComponent from './vue-lazy-component.vue';
// const VueLazyComponent = Vue.extend(lazyComponent);
// // const VueLazyComponent = new lazy({
// //     data: { bindScroll: lazyScroll.bindScroll() }
// // });
// export default VueLazyComponent;



// WEBPACK FOOTER //
// ./src/components/vue-lazy-component/index.js